import { render, staticRenderFns } from "./ReportedIssues.vue?vue&type=template&id=21a2490c&"
import script from "./ReportedIssues.vue?vue&type=script&lang=js&"
export * from "./ReportedIssues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports